import { contractsRegistrySlice } from 'Pages/pp'
import { ChannelHandler, SocketMessage, SocketMessageTypes } from 'Modules/Socket'
import { Callback } from 'Src/types/utilTypes'

export class PartnerContractChannel implements ChannelHandler {
	public constructor(private readonly dispatch: Callback) {
		this.dispatch = dispatch
	}

	public work(data: SocketMessage) {
		const { message } = data
		if (message?.type === SocketMessageTypes.MASS_UPDATE_FINISHED) {
			this.dispatch(
				contractsRegistrySlice.actions.massUpdateContractFinished({ ids: message?.payload?.ids })
			)
		}
	}
}
